export const startsWithPunctuationRegex = /^[.,\/#!$%\^&\*;:=\-_`~)]/

export const isAnEditRegex = /{\+([^|}]*)-([^|]*)\|([^}]*)}/g

export const negativeMatchRegex = /\-(.+)\|/m
